const STEPS = [
  {
    num: "01",
    title: "Apply in 60 seconds",
    body: "Call or WhatsApp us. No resume, no cover letter. Just a quick conversation about your goals.",
  },
  {
    num: "02",
    title: "Get trained",
    body: "Two weeks of in-field shadowing with a top closer. You'll learn the pitch, the product, and the close.",
  },
  {
    num: "03",
    title: "Hit your territory",
    body: "Walk into your assigned neighborhood with confidence. Sell. Service. Stack commissions.",
  },
  {
    num: "04",
    title: "Scale or lead",
    body: "Stay a closer or move into team lead, regional manager, and beyond. Your call.",
  },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32 bg-slate-50 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-blue-600 mb-4">
            The Process
          </p>
          <h2 className="font-heading text-4xl md:text-5xl tracking-tight font-bold text-slate-900">
            From your first knock to your first paycheck — in 14 days.
          </h2>
          <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed">
            The fastest path from application to commission check is here.
          </p>
          <div className="mt-8 hidden lg:block">
            <img
              src="https://images.unsplash.com/photo-1558541966-ee7182e26d63?crop=entropy&cs=srgb&fm=jpg&w=900"
              alt="Door to door sales"
              className="w-full h-72 object-cover grayscale-[0.2]"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <ol className="relative">
            {STEPS.map((step, idx) => (
              <li
                key={step.num}
                data-testid={`process-step-${idx}`}
                className="relative pl-16 pb-10 last:pb-0 border-l border-slate-200 last:border-l-0"
              >
                <span className="absolute -left-px top-0 w-12 h-12 -translate-x-1/2 bg-white border border-slate-200 flex items-center justify-center font-heading font-bold text-blue-600">
                  {step.num}
                </span>
                <h3 className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-slate-900">
                  {step.title}
                </h3>
                <p className="mt-3 text-base md:text-lg text-slate-600 leading-relaxed max-w-xl">
                  {step.body}
                </p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
